import Lidemy from "../../../../slides/theme";
import { CodeSurfer, Step, CodeSurferColumns } from "code-surfer";
import Layout from "../../../../slides/Layout";
import Fullscreen from "../../../../slides/Fullscreen";
import React from 'react';
export default {
  Lidemy,
  CodeSurfer,
  Step,
  CodeSurferColumns,
  Layout,
  Fullscreen,
  React
};